import React from "react";
import { Table } from "react-bootstrap";
import { NUMBER_FORMATS } from "../../../constants/app-constant";
import {
  getCommaSeparatedNumbers,
  getCommaSeparatedNumbersInLocaleFormat,
} from "../../../utility/common-methods";
const InfluencerChart = ({
  chartTitle,
  data,
  onEntityClick,
  isEmbededWidget,
  entityList,
  setFromUserName
}) => {
  const handleUsernameClick = (e, data) => {
    e.preventDefault();
    e.stopPropagation();
    data && window.open(`https://twitter.com/${data}`, "_blank");
    setFromUserName(data)
  };
  const handleCountClick = (e, legend, label, from_username, channelType) => {
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;

      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      routeParams.from_username = from_username;
      routeParams.channel_type = [channelType];
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };
  const convertToInternationalCurrencySystem = (labelValue) => {
    if (!labelValue) return "NA";
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K"
      : Math.abs(Number(labelValue));
  };
  return (
    <div className="customTableWrap">
      <div className="widgetHeading"></div>
      <div className="table-responsive">
        <Table className="table table-sm table-bordered customTable">
          {data && data.length && (
            <thead>
              <tr className="topicRow">
                <th className="thTopicName"></th>
                <th className="thTopicName">Influencers</th>
                <th className="thTopicName">Topic</th>
                <th className="thTopicName">Posts</th>
                <th className="thTopicName">Followers</th>
              </tr>
            </thead>
          )}
          <tbody>
            {Array.isArray(data) &&
              data.map((item, index) => {
                if (!item) {
                  return null;
                }
                const {
                  topic_name,
                  posts,
                  from_username,
                  followers_count,
                  channel_type,
                  user_image,
                } = item || {};
                return (
                  <>
                    <tr key={index}>
                      <td>
                        {/* <span
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                          }} */}
                        <img
                          src={user_image}
                          alt={topic_name}
                          width="25"
                          height="25"
                          style={{ borderRadius: "50%" }}
                        />
                        {/* </span> */}
                      </td>
                      <td>
                        <strong>
                          <a
                            className="influencersLink"
                            onClick={(e) =>
                              handleUsernameClick(e, from_username)
                            }
                          >
                            {`@${from_username}`}
                          </a>
                        </strong>
                      </td>
                      <td>
                        <strong>{topic_name}</strong>
                      </td>
                      <td>
                        <strong>
                          <a
                            onClick={(e) =>
                              handleCountClick(
                                e,
                                null,
                                topic_name,
                                from_username,
                                channel_type
                              )
                            }
                          >
                            {posts}
                          </a>
                        </strong>
                      </td>
                      <td>
                        {convertToInternationalCurrencySystem(followers_count)}
                      </td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default InfluencerChart;
